module.exports = __webpack_public_path__ + "static/media/dark-theme-fuel.24e62084.svg";